import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#242424",
      d: "M11.656 5.338h1.347v2.444l.88.166v-2.61h1.348a.685.685 0 0 0 .681-.682V1.064a.685.685 0 0 0-.681-.681h-3.575a.685.685 0 0 0-.682.681V4.64c-.016.383.3.699.682.699Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "m15.064 8.995-3.258-.598c-.034 0-.067-.033-.084-.05-.316-.382-2.327-2.494-3.64-2.494H3.475c-1.081 0-2.062 1.014-2.677 1.862C.399 8.247.2 8.895.2 9.561v1.928c0 .616.499 1.114 1.114 1.114h.25c.199.799.914 1.397 1.779 1.397.864 0 1.58-.598 1.779-1.397h6.002c.2.799.914 1.397 1.779 1.397.864 0 1.58-.598 1.779-1.397h.033a1.11 1.11 0 0 0 1.098-.964l.182-1.397c.05-.598-.349-1.147-.93-1.246ZM3.31 13.12a.965.965 0 1 1 .965-.964c.016.532-.416.964-.965.964Zm2.178-4.456H2.594c-.15 0-.249-.15-.166-.283.432-.765 1.513-1.513 2.045-1.513h.732c.1 0 .183.067.2.167l.282 1.396a.21.21 0 0 1-.2.233Zm4.656 0H6.95a.197.197 0 0 1-.2-.166L6.468 7.1a.2.2 0 0 1 .2-.233H8.08c.482 0 1.48.765 2.195 1.447.133.133.05.349-.133.349Zm2.727 4.456a.965.965 0 1 1 .001-1.93.965.965 0 0 1-.001 1.93Z"
    }, null, -1)
  ]))]))
}
export default { render: render }